export default __webpack_public_path__ + "images/Reach-Bo-Daily-life.webp";